import PropTypes from "prop-types";
import { getTenseLabel } from "./data.js";

// TODO : Improve phrasing when there is only one verb or one tense
function Description({ verbs, tenses }) {
  return (
    <div>
      <div>Avec cette activité, tu vas valider la conjugaison des verbes :</div>
      <ul style={{ paddingLeft: 40 }}>
        {(verbs || []).map((verb) => (
          <li key={verb}>{verb}</li>
        ))}
      </ul>
      <div>aux temps suivants :</div>
      <ul style={{ paddingLeft: 40 }}>
        {(tenses || []).map((tense) => (
          <li key={tense}>{getTenseLabel(tense)}</li>
        ))}
      </ul>
    </div>
  );
}

Description.propTypes = {
  verbs: PropTypes.arrayOf(PropTypes.string),
  tenses: PropTypes.arrayOf(PropTypes.string),
};

export default Description;
